import React from 'react';
import PropTypes from 'prop-types';
import StyledGlobalStyle from './GlobalStyle.style';
GlobalShadowStyle.propTypes = {
  /** normalize css for better cross browser rendering */
  normalize: PropTypes.bool,

  /** set all elements to use box-sizing: border-box */
  borderBox: PropTypes.bool
};
GlobalShadowStyle.defaultProps = {
  normalize: false,
  borderBox: false
};
export function GlobalShadowStyle(_ref) {
  var normalize = _ref.normalize,
      borderBox = _ref.borderBox;
  return /*#__PURE__*/React.createElement(StyledGlobalStyle, {
    normalize: normalize,
    borderBox: borderBox
  });
}